
export const filmsData = [
    { video: "301393531",   poster: "img/films/blue.jpg",         name: "BLUE"},
    { video: "301361148",   poster: "img/films/makingdreams.jpg", name: "MAKING DREAMS"},
    { video: "301393628",   poster: "img/films/yelow.jpg",        name: "YELOW"},
    { video: "301567324",   poster: "img/films/party.jpg",        name: "PARTY"},
    { video: "301393719",   poster: "img/films/rojo.jpg",         name: "RED"},
    { video: "301393761",   poster: "img/films/rosa.jpg",         name: "PINK"},
    { video: "241209641",   poster: "img/films/city.jpg",         name: "CITY TWO COLLECTION"},
    { video: "190548755",   poster: "img/films/charmings.jpg",    name: "CHARMING COLLECTION"},
    { video: "142366577",   poster: "img/films/atelier.jpg",      name: "45 YEARS OF COLLECTIONS" },
    { video: "78810994",    poster: "img/films/color.jpg",        name: "COLOR COLLECTION" },
]